function OnDiskTrueIcon({ height = '24', width = '24', color = 'currentColor' }) {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 2.00006C6.48 2.00006 2 6.48006 2 12.0001C2 17.5201 6.48 22.0001 12 22.0001C17.52 22.0001 22 17.5201 22 12.0001C22 6.48006 17.52 2.00006 12 2.00006ZM12 20.0001C7.59 20.0001 4 16.4101 4 12.0001C4 7.59006 7.59 4.00006 12 4.00006C16.41 4.00006 20 7.59006 20 12.0001C20 16.4101 16.41 20.0001 12 20.0001ZM16.59 7.58006L10 14.1701L7.41 11.5901L6 13.0001L10 17.0001L18 9.00006L16.59 7.58006Z"
        fill={color}
      />
    </svg>
  );
}

export default OnDiskTrueIcon;
